import { render, staticRenderFns } from "./NoticePayments.vue?vue&type=template&id=26dc8b1a&scoped=true&"
import script from "./NoticePayments.vue?vue&type=script&lang=js&"
export * from "./NoticePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dc8b1a",
  null
  
)

export default component.exports